import React from "react";
import { NavLink } from "react-router-dom";

const MakeupsList = ({ makeups, filmId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Makeup</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/makeup/overview`}
            activeClassName="is-active">
            Overview
          </NavLink>
        </li>
        <hr />
        {makeups?.map((makeup, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/makeup/${makeup.id}/edit`}
                title={makeup.name}
                activeClassName="is-active"
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/makeup/${makeup.id}`
                  );
                }}>
                {makeup.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default MakeupsList;
